var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sort"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 5C1.75 4.58579 2.08579 4.25 2.5 4.25H17.5C17.9142 4.25 18.25 4.58579 18.25 5C18.25 5.41421 17.9142 5.75 17.5 5.75H2.5C2.08579 5.75 1.75 5.41421 1.75 5Z",
    fill: "#06070D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08333 10C5.08333 9.58579 5.41912 9.25 5.83333 9.25H14.1667C14.5809 9.25 14.9167 9.58579 14.9167 10C14.9167 10.4142 14.5809 10.75 14.1667 10.75H5.83333C5.41912 10.75 5.08333 10.4142 5.08333 10Z",
    fill: "#06070D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41667 15C8.41667 14.5858 8.75245 14.25 9.16667 14.25H10.8333C11.2475 14.25 11.5833 14.5858 11.5833 15C11.5833 15.4142 11.2475 15.75 10.8333 15.75H9.16667C8.75245 15.75 8.41667 15.4142 8.41667 15Z",
    fill: "#06070D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.48daadb03ebe519d3e06adecf88688ba.svg";
export { ForwardRef as ReactComponent };